import { useTranslation } from "react-i18next";

const useProjectsData = () => {
  const { t } = useTranslation();

  const projectsData = [
    {
      id: 0,
      name: "$PRICE",
      symbol: "$PRC",
      description: "",
      // "Screx aims to provide a unified and intelligent environment for decentralized finance (DeFi), allowing users...",
      logo: "\pricelogo.png",
      link: "/xen",
      saleType: "live",
      verified: true,
      round: "06",
      currentPrice: "0.05",
      totalRaised: "--",
      startTime: 1764266400000,
      endTime: 1765461600000,
      buyLink: "http://buy.xen.trade/",
      contractAddress: "0xA2B4b493ac1BE5c34f6d482D4816615dA711B902",
      rpc: "https://soft-fluent-needle.arbitrum-mainnet.quiknode.pro/34b9c39696c43031df8a7db438b78194d13463cf/",
      socials: {
        // website: "https://screx.com/",
        // twitter: "https://x.com/screx_com",
        // telegram: "https://t.me/Screx_com",
        // medium: "https://medium.com/@screx",
        // linktree: "https://linktr.ee/screx.com",
        // linkedin: "https://www.linkedin.com/company/screx",
        // galxe: "https://app.galxe.com/quest/VEGTjyWJFwYfvipxJtpfiz",
      },
    },
    // {
    //   id: 1,
    //   name: "Chainers",
    //   symbol: "$CHU",
    //   description:
    //     "Chainers is a multi-genre gaming universe that blends a player-owned Web3 economy with classic...",
    //   logo: "\\assets\\alldetailpages\\chainers\\main-img.png",
    //   link: "/chainers",
    //   saleType: "paused",
    //   verified: true,
    //   notifyName: "CHAINERS",
    //   buyLink: "https://buychainers.gems.vip/",
    //   contractAddress: "0x84F44f2FDC9C2e2d78Fae77d2201F74b88a1bAd9",
    //   rpc: "https://eth-sepolia.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0",
    //   socials: {
    //     website: "https://chainers.io",
    //     twitter: "https://x.com/ChainersGame",
    //     youtube: "https://www.youtube.com/@chainersnft",
    //     medium: "https://medium.com/@chainersgame",
    //     discord: "https://discord.gg/kNpEz2PrcY",
    //     linkedin: "https://www.linkedin.com/company/51-games/",
    //   },
    // },
    // {
    //   id: 2,
    //   name: "XProtocol",
    //   symbol: "$KICK",
    //   description:
    //     "XProtocol is an EVM blockchain backed by Saison Capital, Cogitent Ventures, Founderheads, Razer...",
    //   logo: "\\assets\\alldetailpages\\xprotocol\\main-img.png",
    //   link: "/xprotocol",
    //   name: "XEN",
    //   symbol: "XEN",
    //   description: "Add XEN desription here",
    //   logo: "",
    //   link: "/xen",
    //   saleType: "comingsoon",
    //   verified: true,
    //   buyLink: "",
    //   contractAddress: "0x1Ea5FD07Ad8eA1D35D2ffA34aC76e9C871089807",
    //   socials: {
    //     // website: "https://screx.com/",
    //     // twitter: "https://x.com/screx_com",
    //     // telegram: "https://t.me/Screx_com",
    //     // medium: "https://medium.com/@screx",
    //     // linktree: "https://linktr.ee/screx.com",
    //     // linkedin: "https://www.linkedin.com/company/screx",
    //     // galxe: "https://app.galxe.com/quest/VEGTjyWJFwYfvipxJtpfiz",
    //   },
    // },
    // {
    //   id: 1,
    //   name: "Screx",
    //   symbol: "SCRX",
    //   description:
    //     "Screx aims to provide a unified and intelligent environment for decentralized finance (DeFi), allowing users...",
    //   logo: "\\assets\\alldetailpages\\screx\\screxlogo.svg",
    //   link: "/screx",
    //   saleType: "live",
    //   verified: true,
    //   round: "06",
    //   currentPrice: "0.05",
    //   totalRaised: "--",
    //   startTime: 1764266400000,
    //   endTime: 1765461600000,
    //   buyLink: "http://buyscrex.gems.vip/",
    //   contractAddress: "0x7D765A830e4f23843C0d78FACC7C1069BA197546",
    //   rpc: "https://eth-sepolia.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0",
    //   socials: {
    //     website: "https://screx.com/",
    //     twitter: "https://x.com/screx_com",
    //     telegram: "https://t.me/Screx_com",
    //     medium: "https://medium.com/@screx",
    //     linktree: "https://linktr.ee/screx.com",
    //     linkedin: "https://www.linkedin.com/company/screx",
    //     galxe: "https://app.galxe.com/quest/VEGTjyWJFwYfvipxJtpfiz",
    //   },
    // },
  ];

  return projectsData;
};

export default useProjectsData;
